import { apiFetcher } from './apiFetcher';

interface PresignedUploadResponse {
  uploadUrl: string;
  key: string;
  publicUrl?: string;
}

interface PresignedDownloadResponse {
  downloadUrl: string;
}

export async function requestPresignedUpload(
  bucket: string,
  fileName: string,
  contentType: string
): Promise<PresignedUploadResponse> {
  return apiFetcher<PresignedUploadResponse>('/storage/presigned-upload', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bucket, fileName, contentType }),
  });
}

export async function uploadToS3(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
  });
  if (!response.ok) {
    throw new Error(`S3 upload failed: ${response.status}`);
  }
}

export async function requestPresignedDownload(bucket: string, key: string): Promise<PresignedDownloadResponse> {
  return apiFetcher<PresignedDownloadResponse>('/storage/presigned-download', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bucket, key }),
  });
}

export async function deleteStorageObject(bucket: string, key: string): Promise<void> {
  await apiFetcher<void>('/storage/delete-object', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bucket, key }),
  });
}
